import renderProduct from './cart_modal/render_product';
import renderTotals from './cart_modal/render_totals';

function getCartHTML(products, totals, checkoutButtonText) {
    "use strict";

    return `<div class="main-navigation-sub main-navigation-sub-cart cart-modal">
        <div class="cart-modal__items">
            ${products}
        </div>
    
        <div class="cart-modal__totals">
            ${totals}
        </div>
    
        <div class="cart-modal__actions">
            <a href="${TYROOLA.globals.baseUrl}/checkout/address/">
                <button type="button" class="btn btn-sm btn-primary cart-modal__button">
                    ${checkoutButtonText}
                </button>
            </a>
        </div>
    </div>`;
}

class CartModal {
    constructor() {
        this.customerName = '';
        this.products = [];
        this.expenses = NaN;
    }

    setCustomerName(customerName) {
        this.customerName = customerName;
    }

    setProducts(products) {
        this.products = products;
    }

    setExpenses(expenses) {
        this.expenses = expenses;
    }

    getRenderedModal() {
        return getCartHTML(
            this._getProductsHTML(),
            this._getTotalsHTML(),
            this._getCheckoutButtonText()
        );
    }

    _getCheckoutButtonText() {
        var buyNowText = TYROOLA.translations['header-cart-button-text-buy-now'];
        if (this.customerName) {
            return this.customerName + ', ' + buyNowText;
        } else {
            return buyNowText;
        }
    }

    _getProductsHTML() {
        var productsHTML = '';

        this.products.forEach((product) => {
            productsHTML += renderProduct(product);
        });

        return productsHTML;
    }

    _getTotalsHTML() {
        return renderTotals(this.expenses);
    }
}

export default CartModal;
